import { render, staticRenderFns } from "./DocumentInsert.vue?vue&type=template&id=33c3c734&scoped=true&"
import script from "./DocumentInsert.vue?vue&type=script&lang=js&"
export * from "./DocumentInsert.vue?vue&type=script&lang=js&"
import style0 from "./DocumentInsert.vue?vue&type=style&index=0&id=33c3c734&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c3c734",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VChip,VDialog})
